<template lang="pug">
  model-form(
        ref="form"
        reset-text="limpiar"
        submit-text="Finalizar"
        title="Crear producto"
        :fields="formFields"
        v-model="formData"
        @reset="resetForm"
        @submit="submit"
        )
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
import FieldsCreate from './fields'
/* vuex */
import { mapActions } from 'vuex'
/* model */
import ItemModel from '@/models/Warehouse/WhItem'
/* services */
import Translator from '@/services/translator'
export default {
    name: 'inventory-information',
    props: {
        // value:{
        //   type: Object,
        //   required: true,
        // },
        product: {
            type: Object,
        },
        branchOfficeId: {
            type: Array,
            required: true,
        },
    },
    data: function() {
        return {
            formData: {},
            formFields: FieldsCreate,
        }
    },
    // computed: {},
    methods: {
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        submit() {
            this.$refs.form.setWait(true).then(this.update)
        },
        /*
         */
        update(data) {
            console.log(data, 'data update inventory')
            let branchData = this.getBranchOfficeData(data)
            let updateInfo = this.getUpdateInfo(data, branchData)
            //
            console.log(this.product, 'id product')
            let model = new ItemModel({ id: this.product.product_id })
            model
                .sync(updateInfo)
                .then(r => this.successUpdate(r))
                .then(this.redirect)
                .catch(this.error)
                .then(this.$refs.form.setWait)
        },
        /*
         */
        getBranchOfficeData(inventory) {
            let branchId = this.branchOfficeId
            return branchId.map(id => {
                let branch = {}
                branch.cost_price = 0
                branch.gains_margin = 0
                branch.sale_price = 0
                branch.warranty_days = 0
                if (
                    this.product.branch_office_data &&
                    this.product.branch_office_data.length
                )
                    branch = this.product.branch_office_data.find(
                        b => b.id === id
                    )
                branch.g_branch_office_id = id
                branch.minimum_stock = inventory.minimum_stock
                branch.maximum_stock = inventory.maximum_stock
                branch.critical_stock = inventory.critical_stock
                return branch
            })
        },
        /*
         */
        getUpdateInfo(data, branchData) {
            return {
                ...this.product,
                branch_office_data: branchData,
                warranty_days: this.product.warranty_days || 0,
                is_consumable: this.product.is_consumable || false,
                is_salable: this.product.is_salable || false,
                is_tax_free: this.product.is_tax_free || false,
                //inventory data
                is_inventoriable: data.is_inventoriable || false,
                is_repackaged: data.is_repackaged || false,
                is_seasonal: data.is_seasonal || false,
                uom_quantity: data.uom_quantity,
                wh_unit_of_measurement_id: data.wh_unit_of_measurement_id,
                have_decimal_quantity: data.have_decimal_quantity || false,
            }
        },
        /*
         */
        successUpdate(info) {
            this.setSnackbar({
                type: 'success',
                title: 'Éxito',
                message: 'Información inventario creada exitosamente',
                timeout: 3000,
            })
        },
        error(error) {
            this.setSnackbar({
                type: 'error',
                title: 'Error',
                message: Translator(ItemModel, error.response.data),
                timeout: 15000,
            })
        },
        resetForm() {
            this.formData = {}
            this.formFields[0].props.items = []
        },
        // -- Validations and Error handling
        // -- Other functions
        redirect() {
            this.$router.push('/products')
        },
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            setSnackbar: 'setSnackbar',
        }),
    },
    // watch: {},
    components: {
        'model-form': ModelForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount() {
        this.formData.is_inventoriable = true
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>